/*
	Плагин вставки спойлера, взят отсюда https://github.com/romanvm/TinyMCE4.spoiler
	и немного (?) поправлен
*/
require('@uarm/public/css/tinymce/plugin-spoiler.css');
tinymce.PluginManager.add('spoiler', function (editor) {
	var $ = editor.$;
	editor.contentCSS.push('/uarm-fe/uarm-css/tinymce/plugin-spoiler.css');
	var spoilerCaption = editor.getParam('spoiler_caption', 'Spoiler!');
	let inside = false;

	function initSpoiler() {
		var selection = editor.selection;
		var node = selection.getNode();
		var content = 'Spoiler text.';
		if (node) {
			editor.undoManager.transact(function () {
				if (selection.getContent()) {
					content = selection.getContent();
				}
			});
		}

		return { selection: selection, content: content };
	}

	function checkSpoiler() {
		let parentSpoiler = editor.selection.getNode();

		if (parentSpoiler) {
			parentSpoiler = parentSpoiler.closest('.spoiler');

			if (parentSpoiler && parentSpoiler.parentElement.closest('.spoiler')) {
				return false;
			} else {
				inside = true;

				return true;
			}
		}
		inside = false;

		return true;
	}

	const addSpoilerV = () => addSpoiler('spoiler-details--v');
	const addSpoilerPlus = () => addSpoiler('spoiler-details--plus');

	function addSpoiler(spoilerType) {
		if (checkSpoiler()) {
			var spoiler = initSpoiler();
			spoiler.selection.setContent(`<div class="spoiler spoiler-details ${spoilerType}">
			<button class="details-summary"><span class="details-title"> ${spoilerCaption}</span></button>
			<div class="details ${inside ? 'inside' : ''}"><p class="details-text">${spoiler.content}</p></div>
			</div>`);
			editor.nodeChanged();
		}
	}

	function removeSpoiler() {
		var selection = editor.selection;
		var node = selection.getNode();
		if (node) {
			if (node.className === 'spoiler') {
				replaiceText(node);
			} else if ($(node.closest('.spoiler')).length) {
				node = node.closest('.spoiler');
				replaiceText(node);
			}
		}
	}

	function replaiceText(node) {
		editor.undoManager.transact(function () {
			var newPara = document.createElement('p');
			node.querySelectorAll('p').forEach(function (p) {
				if (p.innerHTML !== 'Spoiler text.') {
					newPara.innerHTML += `${p.innerHTML} `;
				}
			});
			node.parentNode.replaceChild(newPara, node);
		});
		editor.nodeChanged();
	}

	function removeAttr(elems, attr) {
		elems.each(function (index, elem) {
			if (elem.hasAttribute(attr)) {
				elem.removeAttribute(attr);
			}
		});
	}

	editor.on('PreProcess', function (evt) {
		removeAttr($('div[class*="spoiler"]', evt.node), 'contenteditable');
		removeAttr($('[class*="details"]', evt.node), 'contenteditable');
		removeAttr($('button[class="details-summary"]', evt.node), 'disabled');
	});

	editor.on('SetContent', function () {
		$('div[class*="spoiler"]').each(function (index, elem) {
			if (!elem.hasAttribute('contenteditable')) {
				var $elem = $(elem);
				if ($elem.hasClass('spoiler')) {
					elem.contentEditable = false;
				} else if ($elem.hasClass('spoiler-text')) {
					elem.contentEditable = true;
				}
				if ($elem.hasClass('spoiler-toggle')) {
					elem.contentEditable = true;
				}
			}
		});

		$('[class*="details"]').each(function (index, elem) {
			if (!elem.hasAttribute('contenteditable')) {
				var $elem = $(elem);
				elem.contentEditable = !$elem.hasClass('details-summary');

				if (elem.classList.contains('details-summary') && !elem.hasAttribute('disabled')) {
					elem.disabled = true;
				}

				if (elem.classList.contains('details') || elem.classList.contains('details-summary')) {
					let start = '';
					let old = '';
					let subelem = '';
					let selector = '';
					if (elem.querySelector('.details-text')) {
						selector = '.details-text';
					} else if (elem.querySelector('.details-title')) {
						selector = '.details-title';
					}
					if (selector.length) {
						subelem = elem.querySelector(selector);
						start = subelem.textContent;

						const observer = new MutationObserver((mutationRecords) => {
							mutationRecords.forEach(function (record) {
								if (record.oldValue) {
									old = record.oldValue;
								}
								if (record.removedNodes.length) {
									record.removedNodes.forEach(function (removed) {
										if (removed.nodeType === 1) {
											if (removed.classList.contains('details-text')) {
												const spoiler = document.createElement('p');
												spoiler.classList.add('details-text');
												spoiler.contentEditable = true;
												if (old.length > 1) {
													spoiler.textContent = old;
												} else {
													spoiler.textContent = start;
												}
												elem.appendChild(spoiler);
												subelem = elem.querySelector(selector);
											}
										}
									});
								}
								if (record.addedNodes.length && subelem.classList.contains('details-title')) {
									record.addedNodes[0].remove();
								}
							});
						});

						observer.observe(elem, {
							childList: true, // наблюдать за непосредственными детьми
							subtree: true, // и более глубокими потомками
							characterDataOldValue: true, // передавать старое значение в колбэк
						});
					}
				}
			}
		});
	});

	editor.addButton('spoiler-add', {
		type: 'menubutton',
		tooltip: 'Выбрать спойлер',
		image: '/uarm-fe/uarm-images/eye-plus.svg',
		menu: [
			{ text: '"+/-" образный', onclick: addSpoilerPlus },
			{ text: '"V" образный', onclick: addSpoilerV },
		],
	});

	editor.addMenuItem('spoiler-add', {
		text: 'Выбрать спойлер',
		context: 'format',
	});

	editor.addButton('spoiler-remove', {
		tooltip: 'Удалить спойлер',
		image: '/uarm-fe/uarm-images/eye-off-line.svg',
		onclick: removeSpoiler,
	});

	editor.addMenuItem('spoiler-remove', {
		text: 'Удалить спойлер',
		context: 'format',
		onclick: removeSpoiler,
	});
});
